"use client";
import {
  GroupLabelContext
} from "./3X3MDQGM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./5M6RSQEC.js";
import {
  useWrapElement
} from "./6O5OEQGF.js";
import {
  __spreadValues
} from "./4R3V3JGP.js";

// src/group/group.tsx
import { useState } from "react";
import { removeUndefinedValues } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useGroup = createHook(
  function useGroup2(props) {
    const [labelId, setLabelId] = useState();
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(GroupLabelContext.Provider, { value: setLabelId, children: element }),
      []
    );
    props = __spreadValues({
      role: "group",
      "aria-labelledby": labelId
    }, props);
    return removeUndefinedValues(props);
  }
);
var Group = forwardRef(function Group2(props) {
  const htmlProps = useGroup(props);
  return createElement(TagName, htmlProps);
});

export {
  useGroup,
  Group
};
